import React from 'react';
import Brick from './Brick';
import { EmailLayoutsField } from '../../components';
import { Field } from 'redux-form';
import { Col, FormGroup, Label } from 'reactstrap';

/** Class representing a workflow brick to
 * send an email
 *
 * [server_side]
 */
class EmailSendBrick extends Brick {
    /**
     * Get this brick options form
     *
     * @param {Object} props: an object with the following keys
     *                          - t
     *                          - workflow
     *                          - forms
     *                          - emails
     *                          - articles
     *                          - salepoints
     */
    getOptionsForm(props) {
        const { t, emails } = props;

        if (!emails)
            return null;

        return (
            <>
                <FormGroup row>
                    <Label for="layout_id" className="text-v-center" sm={4}>
                        { t('workflows.bricks.email.send.options.layout_id') }
                    </Label>
                    <Col sm={8}>
                        <EmailLayoutsField emailLayouts={emails} name={`bricks[${this.position}].options.layout_id`} single />
                    </Col>
                </FormGroup>
                <FormGroup row>
                    <Label for="recipients" className="text-v-center" sm={4}>
                        { t('workflows.bricks.email.send.options.recipients') }
                    </Label>
                    <Col sm={8}>
                        <Field component="input" type="text" name={`bricks[${this.position}].options.recipients`} className="form-control" />
                    </Col>
                </FormGroup>
            </>
        );
    }
}

export default EmailSendBrick;
